import React, { lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { getAccessToken, getRefreshToken } from '@ecp/common/src/utils/utils';

import NotFoundErrorPage from '../pages/error/NotFoundErrorPage';

const PartnerLoginPage = lazy(() => import('../pages/po/POLoginPage'));
const PartnerLogoutPage = lazy(() => import('../pages/po/POLogoutPage'));
const PartnerAccountAdditionalInfoPage = lazy(() => import('../pages/po/member/AccountAdditionalInfoPage'));
const PartnerVendorAgreementPage = lazy(() => import('../pages/po/vendor/agreement/VendorAgreementPage'));

const PoPublicRoutes = () => {
  const accessToken = getAccessToken();
  const refreshToken = getRefreshToken();

  return accessToken && refreshToken ? (
    <Navigate to="/" />
  ) : (
    <Routes>
      <Route path="login" element={<PartnerLoginPage />} />
      <Route path="logout" element={<PartnerLogoutPage />} />
      <Route path="account-additional-info" element={<PartnerAccountAdditionalInfoPage />} />
      <Route path="vendor/vendor-agreement" element={<PartnerVendorAgreementPage />} />
      <Route path="*" element={<NotFoundErrorPage />} />
    </Routes>
  );
};

export default PoPublicRoutes;
